import type { LiquidProductVariant } from "../../models/shopify/liquid/variant"

/**
 * Normalises protocol-relative Liquid image URLs for use in CSS or img src.
 */
export function normalizeLiquidImageUrl(options: { src: string }): string {
  const s = options.src.trim()
  if (s.length >= 2 && s[0] === "/" && s[1] === "/") {
    return `https:${s}`
  }
  return s
}

/**
 * Featured image or variant image src from a Liquid product variant JSON object.
 */
export function getLiquidProductVariantImageSrc(options: {
  variant: LiquidProductVariant
}): string | null {
  const { variant } = options
  const featured = variant.featured_image
  if (
    typeof featured === "object" &&
    featured !== null &&
    "src" in featured &&
    typeof (featured as { src: unknown }).src === "string"
  ) {
    return normalizeLiquidImageUrl({ src: (featured as { src: string }).src })
  }
  const img = variant.image
  if (
    typeof img === "object" &&
    img !== null &&
    "src" in img &&
    typeof (img as { src: unknown }).src === "string"
  ) {
    return normalizeLiquidImageUrl({ src: (img as { src: string }).src })
  }
  return null
}
